export const getEntitiesUpdated = (state) => state.getIn(['entities', 'metaInformation', 'entitiesUpdated']);
